import Image from 'components/common/Image'

const RoundedCover = ({ src, placeholder }) => {
  return (
    <div className="flex justify-center mb-4 h-0 w-full relative" style={{ paddingBottom: '100%' }}>
        <div className="absolute left-0 top-0 w-full h-full rounded-full overflow-hidden">
            <Image src={src} className="object-cover" alt="" placeholder={placeholder} />
        </div>
    </div>
  )
}

export default RoundedCover